import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CityService } from '../../services/city.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    City,
    ThirdPartyCompany
} from '../../models/models';

@Component({
    selector: 'third-party-company-form',
    templateUrl: './third-party-company-form.component.html',
    standalone: false
})
export class ThirdPartyCompanyForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: ThirdPartyCompany = {} as ThirdPartyCompany;
    public cityID: number = 0;
    public city: City = {} as City;

    public formGroup: UntypedFormGroup = new UntypedFormGroup({
        cityCtrl: new UntypedFormControl('')
    });

    constructor(private cityService: CityService, private orderService: OrderService,
        private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.orderService.getThirdPartyCompanyByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                    this.cityID = this.tableItem.cityID;
                    this.cityService.getCityByID(this.cityID).subscribe(result2 => {
                        if (result2.resultCollection.length > 0) {
                            this.city = result2.resultCollection[0];
                        }
                    })
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                thirdPartyCompanyID: 0,
                thirdPartyCompanyCode: "",
                thirdPartyCompanyName: "",
                address1: "",
                address2: "",
                cityID: 0,
                createDate: new Date(),
                externalCompanyID: 0
            };
        }
    }

    public citySTChanged(evt: any, ctrl: string) {
        var cityID = evt;
        //console.log("citySTChanged", cityID, this.customerCity);
        this.cityService.getCityByID(cityID).subscribe(result => {
            if (result.resultCollection.length > 0) {
                var city: City = result.resultCollection[0];
                if (ctrl == "cityCtrl") {
                    this.cityID = city.cityID;
                    this.tableItem.cityID = this.cityID;
                    console.log("citySTChanged:pickCity", cityID, this.cityID, result);
                }
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.orderService.saveThirdPartyCompany(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as ThirdPartyCompany;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
